<template>
  <div
    class="text-orange-600 bg-orange-200 rounded-4px text-13px leading-[1.5] font-semibold py-2px px-6px"
  >
    {{ _t('cardview.wrong_card_badge') }}
  </div>
</template>
<script setup lang="ts"></script>
<style scoped></style>
